import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// sample page routing
const Dashboard = Loadable(lazy(() => import('views/pages/global-dashboard')));
const UserProfilePage = Loadable(lazy(() => import('views/pages/user-profile')));
const OrganisationProfilePage = Loadable(lazy(() => import('views/pages/org-profile')));
const PipelinePage = Loadable(lazy(() => import('views/pages/pipeline')));
const ProjectsPage = Loadable(lazy(() => import('views/pages/projects')));
const LibraryPage = Loadable(lazy(() => import('views/pages/library')));
const EntitiesPage = Loadable(lazy(() => import('views/pages/entities')));
const Artefacts = Loadable(lazy(() => import('views/pages/artefacts')));
const Domains = Loadable(lazy(() => import('views/pages/domains')));
const Documents = Loadable(lazy(() => import('views/pages/documents')));
const GoalsPage = Loadable(lazy(() => import('views/pages/goals')));
const GoalPage = Loadable(lazy(() => import('views/pages/goals/Goal')));
// The ViewPoint landing page — a project's analysis as at one run. It serves the project's landing
// route (newest ViewPoint) and the run-scoped one, which is what the selector navigates to.
const ViewpointPage = Loadable(lazy(() => import('views/pages/viewpoint')));
// The Cognitives pages (Cognitives spec screens 1 and 2), scoped to a ViewPoint the same way: the
// project-level routes show the chosen ViewPoint, or the latest if none is chosen.
const CognitivesPage = Loadable(lazy(() => import('views/pages/cognitives')));
const CognitivePage = Loadable(lazy(() => import('views/pages/cognitives/Cognitive')));


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: 'user-account',
      element: <UserProfilePage />
    },          
    {
      path: 'organisation-account',
      element: <OrganisationProfilePage />
    },    
    {
      path: 'pipeline',
      element: <PipelinePage />
    },   
    {
      path: 'projects/:projectId/artefacts',
      element: <Artefacts />
    },
    {
      path: 'projects/:projectId/domains',
      element: <Domains />
    },
    {
      path: 'projects/:projectId/documents',
      element: <Documents />
    },
    {
      path: 'projects/:projectId/dashboard',
      element: <ViewpointPage />
    },
    {
      path: 'projects/:projectId/viewpoint/:runId',
      element: <ViewpointPage />
    },    
    { path: 'projects/:projectId/cognitives', element: <CognitivesPage /> },
    { path: 'projects/:projectId/cognitives/:cogCode', element: <CognitivePage /> },
    { path: 'projects/:projectId/viewpoint/:runId/cognitives', element: <CognitivesPage /> },
    { path: 'projects/:projectId/viewpoint/:runId/cognitives/:cogCode', element: <CognitivePage /> },
    { path: 'projects/:projectId/goals', element: <GoalsPage /> },
    { path: 'projects/:projectId/goals/:goalCode', element: <GoalPage /> },
    { path: 'projects/:projectId/viewpoint/:runId/goals', element: <GoalsPage /> },
    { path: 'projects/:projectId/viewpoint/:runId/goals/:goalCode', element: <GoalPage /> },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'entities',
      element: <EntitiesPage />
    },
    {
      path: 'doc-hub',
      element: <LibraryPage />
    },
    {
      path: 'projects',
      element: <ProjectsPage />
    }
  ]
};

export default MainRoutes;
